import { ICta } from 'interfaces/cta';
import { IDisclaimer } from 'interfaces/disclaimer';

const currencyFormatter = new Intl.NumberFormat('en-US', {
  style: 'currency',
  currency: 'USD',
  maximumFractionDigits: 0,
  minimumFractionDigits: 0,
});

export function formatDisclaimer(disclaimer: IDisclaimer): string {
  return JSON.stringify([
    [
      {
        disclaimer: {
          content: `<b>${disclaimer.title}</b></br>${disclaimer.content}`,
          trigger: disclaimer.mark,
        },
      },
    ],
  ]);
}

export function formatLink(link: ICta, isExternal: boolean = false): string {
  return JSON.stringify([
    [
      {
        link: {
          label: link.label,
          target: link.target,
          url: link.url,
          isExternal: isExternal,
        },
      },
    ],
  ]);
}

export function parseCurrency(amount: number): string {
  return amount ? currencyFormatter.format(amount) : '$0';
}

export function removeDisclaimerFromText(text?: string): string {
  return (text?.includes('[[') ? text?.split('[[')[0] : text) || '';
}

//Create html element to extract the text from the input value
export function cleanHTMLFromString(html?: string): string {
  const div = document.createElement('div');
  div.innerHTML = html || '';
  return div.textContent || div.innerText || '';
}

export const jsonDisclaimerLinkTester = (text: string) => {
  try {
    const object = JSON.parse(text);
    return object.disclaimer || object.link ? true : false;
  } catch (e) {
    return false;
  }
};
export const jsonParser = (text: string) => {
  try {
    const parsedJson = JSON.parse(text.replace(/'/gi, '"'));
    return parsedJson;
  } catch (e) {
    return false;
  }
};

export function cleanDisclaimerFromString(text: string): string {
  const foundText = text.match(/<a href=".*?>.*?<\/a>| ".*?" /g);
  var processedText = text;
  if (foundText) {
    foundText.forEach(
      (element) => (processedText = processedText.replace(element, ''))
    );
  }
  const separateString = processedText.split(/\[\[|\]\]/);
  var cleanText = '';
  separateString.forEach((element) => {
    if (jsonDisclaimerLinkTester(element)) {
      const foundObject = JSON.parse(element);
      cleanText = cleanText + (foundObject?.disclaimer?.trigger || '');
    } else {
      cleanText = cleanText + element;
    }
  });
  return cleanText;
}

export function createIdFromText(text?: string) {
  return text
    ?.toLowerCase()
    .replace(/\s/g, '-')
    .replace(/[^a-z0-9]/gi, '');
}

export function formatError(errorMsg?: string): string {
  const msgParts = errorMsg
    ?.substring(errorMsg.indexOf(']') + 1)
    // remove starting and trailing whitespace and dashes
    .replace(/^(\s|-)*|(\s|-)*$/g, '')
    // negative lookahead, split only on dots not followed by digits
    // we just want lines
    .split(/\.(?!\d)/)
    .map((part: string) => {
      if (!part.includes(':') && part.length > 3) {
        return `${part}. `;
      }

      return '';
    });

  return msgParts?.join('') || '';
}
